$(document).ready(function(){
  $('.home_pro_list').slick({
    dots:false,
    infinite: false,   
    slidesToShow:4,
    responsive: [
      {
        breakpoint: 1199,
        settings: {

          slidesToShow: 3
        }
      },
      {
        breakpoint: 649,
        settings: {

          slidesToShow: 2
        }
      },
      {
        breakpoint: 481,
        settings: {

          slidesToShow: 1,
          variableWidth: true
        }
      },
      {
        breakpoint: 401,
        settings: {

          slidesToShow: 1,
          variableWidth: true
        }
      }
    ]
  });
  /* Product slider */
  $('.product-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,   


    arrows: true,
    fade: true,
    asNavFor: '.product-single__thumbnails',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          dots: true,infinite: true,touchAction: "auto",
        }
      }
    ]
  });
  $('.product-single__thumbnails').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: '.product-main',
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    focusOnSelect: true,
    vertical: true,
    focusOnSelect: true,
    verticalSwiping: false
  });

  $('.product-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;   
    $('.product-single__thumbnails .slick-slide').removeClass('slick-current');
    $('.product-single__thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-current');
    // $('.product-single__thumbnails').slick('slickGoTo', mySlideNumber);
  });

  $('.item-swatch li').click(function(){
    $(this).addClass('active');
    $(this).siblings('li').removeClass('active');
    var url = $(this).attr('data-url');
    $(this).parents('.product-card').find('.pro_url').attr('href',url);
  });

  $('.product-card .pro_content').matchHeight({
    property: 'height'
  });
  $('.question-grid .question-title').matchHeight({
    property: 'height'
  });
  if($(window).width() > 991){
    $('.product-main-images').on('afterChange', function(event, slick, currentSlide, nextSlide){
      var img_url_temp = $(this).find('img').attr('src');
      var imgs = $('.image_zoom_cls');
      $('.zoomContainer').remove();
      imgs.removeData('elevateZoom');
      imgs.removeData('zoomImage');
      var temp_zoom_cls = '.image_zoom_cls-'+currentSlide;
      setTimeout(function(){
        $(temp_zoom_cls).elevateZoom({
          zoomWindowPosition: "productInfoContainer"
        });
      }, 1000);
    });    
  }
  $('.clickme a').click(function(){
    $('.clickme a').removeClass('activelink');
    $(this).addClass('activelink');
    var tagid = $(this).data('tag');
    $('.list').removeClass('active').addClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
  });
  function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
      return false;
    }else{
      return true;
    }
  }
  function ScrollTop(){
    $("html, body").animate({ scrollTop: 0 }, "false");
  }
  $('#RegisterForm').submit(function(e) {
    var firstName = $('#RegisterForm-FirstName');
    var lastName = $('#RegisterForm-LastName');
    var email = $('#RegisterForm-email');
    var phoneNumber = $('#RegisterForm-phone');
    var Pass = $('#RegisterForm-password');
    var ConformPass = $('#RegisterForm-confirm-password');
    if(!firstName.val()){
      firstName.addClass('input--error');
      ScrollTop();
      return false;
    }else{
      firstName.removeClass('input--error');
    }
    if(!lastName.val()){
      lastName.addClass('input--error');
      ScrollTop();
      return false;
    }else{
      lastName.removeClass('input--error');
    }
    if(IsEmail(email.val())==false){
      email.addClass('input--error');
      ScrollTop();
      return false;
    }else{
      email.removeClass('input--error');
    }
    if(!phoneNumber.val()){
      phoneNumber.addClass('input--error');
      ScrollTop();
      return false;
    }else{
      phoneNumber.removeClass('input--error');
    }
    if(!Pass.val()){
      Pass.addClass('input--error');
      ScrollTop();
      return false;
    }else{
      Pass.removeClass('input--error');
    }
    if(!ConformPass.val()){
      ConformPass.addClass('input--error');
      ScrollTop();
      return false;
    }else{
      ConformPass.removeClass('input--error');
    }
    if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
      e.preventDefault();
      alert('Passwords do not match.');
      return false;
    }
  });
  if($(window).width() < 750){
    $(document).on('click','.footer-collapse-trigger',function(){
      $(this).next('.footer-collapse-content').slideToggle('fast');
      $(this).toggleClass('active');
    });
  }
});
$(window).on('load',function(){
  if($(window).width() > 991){
    setTimeout(function(){
      $('.product-main-images .slick-active img').elevateZoom({
        zoomWindowPosition: "productInfoContainer"
      });
    }, 1000);
  }
  /*$('#recently-viewed-products .product_img .pro_url').matchHeight({
    property: 'height'
  });*/
  $('.product-card .pro_content').matchHeight({
    property: 'height'
  });
  setTimeout(function(){
    $('#recently-viewed-products').slick({
      dots:false,
      slidesToShow:4,
      slide: '.recent-pro',
      responsive: [
        {
          breakpoint: 1199,
          settings: {

            slidesToShow: 3
          }
        },
        {
          breakpoint: 649,
          settings: {

            slidesToShow: 2
          }
        },
        {
          breakpoint: 481,
          settings: {

            slidesToShow: 1,
            variableWidth: true
          }
        },
        {
          breakpoint: 401,
          settings: {

            slidesToShow: 1,
            variableWidth: true
          }
        }
      ]
    });
  },2000);
  $('.close-model, .popup-open').click(function(){
    $('body').removeClass('popup-open');
  });
  $('.size-guide-trigger').click(function(){
    $('body').addClass('popup-open');
  });
});
$(document).on('click','.share-link',function(e){
  e.preventDefault();
  var shareLink = $(this).attr('href');
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val(shareLink).select();
  document.execCommand("copy");
  $temp.remove();
  $(this).find('.icon-copy').hide();
  $(this).find('.icon-tick').show();
});
$(document).on('click','.sharing-trigger',function(e){
  $(this).next('.sharing-content').slideToggle('fast');
  return false;
});
$(document).on('click','.close-sharing',function(e){
  $(this).parents('.sharing-content').slideToggle('fast');
  return false;
});

$(document).on('click','body',function(e){
  var STContainer = $(".sharing-content");
  if (!STContainer.is(e.target) && STContainer.has(e.target).length === 0) {
    $('.sharing-content').slideUp();

  }
});



var header_height = $('#shopify-section-header').innerHeight();
$(document).on('click', '.accordion-tigger', function(e) {
  $('.accordion-box').find('.accordion-content').stop().slideUp('fast');
  $(this).closest('.accordion-box').find('.accordion-content').stop().slideToggle('fast');
  if($(this).hasClass('active')){
    $(this).removeClass('active');
  }else{
    $('.accordion-box').find('.accordion-tigger').removeClass('active');
    $(this).addClass('active');
  }
});

$(document).on('click', '.mobile-filter-trigger', function(e) {   
  $('body').toggleClass("filter_open");
  return false;
});

$(document).on('click', '.fillter_overlay', function(e) {   
  $('body').removeClass("filter_open");
  return false;
});
$(document).on('click', '.filter-close-trigger', function(e) {   
  $('body').removeClass("filter_open");
  return false;
});

$(document).on('click', '.js-mobile-nav-toggle', function(e) {   
  $('body').addClass("mobile-nav-is-open");
  return false;
});
$(document).on('click', '.mobileNavClose,.mobile-nav-overlay', function(e) {   
  $('body').removeClass("mobile-nav-is-open");
  $('.mobile-nav-wrapper').removeClass("js-menu--is-open");
  return false;
});


$(document).on('click', '.tab-trigger a', function(e) {
  e.preventDefault();
  $('.tab-trigger a').removeClass('activelink');
  $(this).addClass('activelink');
  var tagid = $(this).data('tag');
  $('.tab-content').removeClass('active').addClass('hide');
  $('#'+tagid).addClass('active').removeClass('hide');
});
$(document).on('change','.product-qty-select',function(){
  var value = $(this).val();
  if(value == 10 || value == '10'){
    $(this).addClass('hide');
    $(this).next('.product-qty-input').removeClass('hide');
    location.reload();  
  }
});
$(document).on('change','.cart-size_variants',function(){
  var selectedSize = $(this).find(':selected').attr('data-title');
  var productId = $(this).data('id');
  var currenctSize = $(this).data('size');
  var NewVariantTitle = '';
  var total = $('#product-details--'+productId+' .product-details__item--variant-option').length;
  var productQty = Number($('#item-qty--'+productId).data('qty'));
  $('#product-details--'+productId+' .product-details__item--variant-option').each(function(index){
    var variantTitle = $(this).data('variant');
    if (index === total - 1) {
      NewVariantTitle = NewVariantTitle + variantTitle;
    }else{
      NewVariantTitle = NewVariantTitle + variantTitle + ' / ';
    }
  });
  NewVariantTitle = NewVariantTitle.replace(currenctSize,selectedSize);
  $('#item-variants--'+productId+' option[data-title="'+NewVariantTitle+'"]').attr('selected','selected').change();
  var newProductId = $('#item-variants--'+productId).val();
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data:'quantity=0&id='+productId,
    dataType: "json",
    beforeSend: function() {
      $('body').addClass('loading');
    },
    success: function(update) {             
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data : { id: newProductId, quantity: productQty},
        dataType: "json",
        success: function(data) {
          location.reload();
        },
        error: function(xhr, status, error) {
          console.log(xhr.status);
        }
      });                                  
    },
    error: function(error) {
      console.log(error);        
    }
  });

});

function find_soldout_variant(){
  $('.pair_with_grid').each(function(grid_index){
    var pair_grid_this = $(this);
    var color_selected = pair_grid_this.find('.color-wrap input:checked').val();
    pair_grid_this.find('.pair_product_select option').each(function(option_index){
      var option_this = $(this);
      var option_title = option_this.data('title');

      // console.log(option_title.indexOf(color_selected));


      if(option_title.indexOf(color_selected) != -1){
        option_title = option_title.replace(color_selected,'');
        option_title = option_title.replace(' / ','');

        if(option_this.data('available') == false){
          pair_grid_this.find('.th_variants_div .th_pair_swatch_input[value="'+option_title+'"]').prop('disabled', true);
          pair_grid_this.find('.th_variants_div .wc_swatches_label[data-value="'+option_title+'"]').addClass('wc_soldout');
        } else{
          pair_grid_this.find('.th_variants_div .th_pair_swatch_input[value="'+option_title+'"]').prop('disabled', false);
          pair_grid_this.find('.th_variants_div .wc_swatches_label[data-value="'+option_title+'"]').removeClass('wc_soldout');
        }
      }else{
        if(option_this.data('available') == false){
          pair_grid_this.find('.th_variants_div .th_pair_swatch_input[value="'+option_title+'"]').prop('disabled', true);
          pair_grid_this.find('.th_variants_div .wc_swatches_label[data-value="'+option_title+'"]').addClass('wc_soldout');
        } 
      }
    });
  });
}

$(document).on('change', '.th_pair_swatch_input', function(){    
  var input_this = $(this);
  var this_parents = input_this.parents('.pair_with_grid');
  var th_selected_val = new Array();
  this_parents.find('.th_variants_div').each(function(index){
    var input_selected_val = $(this).find('.th_pair_swatch_input:checked').val();
    var input_selected_size = $(this).find('.th_pair_swatch_input:checked').size();
    th_selected_val.push(input_selected_val);
    if(index === this_parents.find('.th_variants_div').length - 1){
      console.log(input_this);
      var final_selected_val =  th_selected_val.join(" / ");
      input_this.parents('.pair_with_grid').find('.pair_product_select').prop('selected', false);
      input_this.parents('.pair_with_grid').find('.pair_product_select option[data-title="'+final_selected_val+'"]').prop('selected', true).trigger('change');
    }
  });
  find_soldout_variant();
});




$(document).on('change', '.pair_product_select', function(){
  var th_selected_val = $(this).find('option:selected');
  var th_vari_price = th_selected_val.data('price');
  var th_vari_compare_price = th_selected_val.data('compare-price');
  var th_vari_price_only = th_vari_price.replace('$', '');
  var th_vari_compare_price_only = th_vari_compare_price.replace('$', '');
  var th_vari_available = th_selected_val.data('available');
  var th_vari_id = th_selected_val.val();
  $(this).parents('.pair_with_grid').find('button.wc_product_cart_submit').attr('data-pair_id',th_vari_id);
  // Start of Swym Button Variant Change
  $(this).parents('.pair_with_grid').find('#swym-pair-view').attr('data-variant-id',th_vari_id);
  if(_swat){_swat.initializeActionButtons("div.product-pair-with-wrap")};
  // End of Swym Code
  $(this).parents('.pair_with_grid').find('.product_price').text(th_vari_price);
  if(parseFloat(th_vari_compare_price_only) > parseFloat(th_vari_price_only)){
    $(this).parents('.pair_with_grid').find('.product_compare_price').text(th_vari_compare_price);
    $(this).parents('.pair_with_grid').find('.product_compare_price').show();
    $(this).parents('.pair_with_grid').find('.shop-price').addClass('sp_comp');
  } else{
    $(this).parents('.pair_with_grid').find('.product_compare_price').hide();
    $(this).parents('.pair_with_grid').find('.shop-price').removeClass('sp_comp');
  }
  var add_to_cart_text = 'Add To Bag';
  var sold_out_text = 'Sold Out';
  
  if(th_vari_available == 'true' || th_vari_available){
    $(this).parents('.pair_with_grid').find('button.wc_product_cart_submit').prop('disabled', false).text(add_to_cart_text);
  } else{
    $(this).parents('.pair_with_grid').find('button.wc_product_cart_submit').prop('disabled', true).text(sold_out_text);
  }
  find_soldout_variant();
});

$(window).on("load", function(){
  $('.pair_with_grid').each(function(index){
    var swatch_pair_title = $(this).find('.color-wrap input:checked').val();
    $(this).find('.color-guide-swatch').text(swatch_pair_title);      
    find_soldout_variant();
  });
});


$(document).on('click','.pair-swatch',function(){
  $(this).prev("input").trigger('click')
});

$(document).on('click','#question-label',function(e){
  $(this).next('.question-list').slideToggle();
});
$(document).on('click','.promo-code-trigger',function(e){
  $('#dcodeOuterWrapper').slideToggle('fast');
});
$(document).on('click','.question-type-trigger',function(e){
  e.preventDefault();
  var QuestionType = $(this).data('value');
  if(QuestionType == '-'){
    $('#qa-grid').hide();
    $('.question-list').slideToggle();
  }else{
    $('#contact-questions-types').removeClass('show');
    $('#contact-questions-grid').addClass('show');
    $('#contact-questions-grid li[data-type="'+QuestionType+'"]').removeClass('hide');
  }
});
$(document).on('click','.back-trigger',function(e){
  e.preventDefault();
  $('#contact-questions-grid').removeClass('show');
  $('#contact-questions-types').addClass('show');
  $(this).parent('li').siblings().addClass('hide');
});
$(document).on('click','.question-trigger',function(e){
  $('.question-list').slideToggle();
  var SelectedType = $(this).data('type');
  var selectedQuestion = $(this).text();
  $('#question-label-text').text(selectedQuestion);
  $('#qa-list .accordion-box').addClass('hide');
  $('#qa-list .accordion-box[data-type="'+SelectedType+'"]').removeClass('hide');
  $('#qa-grid').show();
  $('html, body').animate({
    scrollTop: ($('#qa-grid').offset().top)
  }, 800);
});
/*$(document).on('click','.faq-tabs-wrap .accordion-tigger',function(e){
  e.preventDefault();
  var headerHeight = $('div[data-section-id="header"]').outerHeight();
  $('html, body').animate({
    scrollTop: ($(this).offset().top - headerHeight)
  }, 800);
});*/
$(document).on('click','#contact-trigger',function(e){
  e.preventDefault();
  $('#question-selection-id').hide();
  $('#contact-options-id').show();
});
$(document).on('click','.footer_social_country h6',function(e){
  $(this).parents('.footer_social_country').find('ul').slideToggle();
  $(this).toggleClass('is_open');
  return false;
});
$(document).on('click','body',function(e){
  var container = $(".footer_social_country ul");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.footer_social_country ul').slideUp();
    $('.footer_social_country h6').removeClass('is_open');
  }
});

$(document).on('click','button.head_currency_toggle',function(e){
  $(this).parents('.head_currency_select').find('ul').slideToggle();
  $(this).toggleClass('is_active');
  return false;
});
$(document).on('click','body',function(e){
  var container = $(".head_currency_select ul");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.head_currency_select ul').slideUp();
    $('button.head_currency_toggle').removeClass('is_active');
  }
});




$(document).on('click','.sort-bt-trigger',function(e){
  $(this).next('.sort-by-list').slideToggle('fast');
});
$(document).on('mouseenter','.site-nav--has-dropdown',function(){
  $(this).addClass('site-nav--active-dropdown');
});
$(document).on('mouseleave','.site-nav--has-dropdown',function(){
  $(this).removeClass('site-nav--active-dropdown');
});

$(window).on("load", function() {
  var swatchtitle = $('.product-form-product-template .color-wrap input:checked').val();

  $('.color-guide-swatch').text( swatchtitle );
  //$(".pro_color input:checked").parent('.swatch-element').find('label').trigger( "click" );
});

$(document).on('click','.color-wrap label',function(e){
  var change_swatcht = $(this).data('title');
  $(this).parents('.product_swatch_group').find('.color-guide-swatch').text( change_swatcht );
});
$(document).ready(function(){
  $(document).on('click', '.wc_swatches_label', function(){
    var $this = $(this);
     setTimeout(function(){ $this.closest('.shop_overlay').find('.wc_product_cart_submit').trigger('click'); }, 50);
  });
});